import { useState } from "react";
import Input from "../../components/Input";
import { useAlert } from "react-alert";
import { useTranslation } from "react-i18next";
import ENV from "../../env";

export default function CheckFunds() {
  const [loading, setLoading] = useState(false);
  const [cardId, setCardId] = useState("");
  const [foundCard, setFoundCard] = useState(null);
  const alert = useAlert();
  const { t } = useTranslation("cashless");

  const onSearch = async () => {
    const normalizedCardId = cardId.toUpperCase().trim();
    if (!normalizedCardId) {
      setFoundCard(null);
      alert.show(t("enterYourCardId"), { type: "error" });
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${ENV.firebaseApiUrl}/cashless/public-card-balance`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cardId: normalizedCardId }),
      });

      if (response.status === 429) {
        setFoundCard(null);
        alert.show(t("checkFundsTooManyRequests"), { type: "error" });
        return;
      }

      if (!response.ok) {
        throw new Error("Public cashless balance lookup failed");
      }

      const result = await response.json();
      if (result.found) {
        setFoundCard({ currentAmount: Number(result.currentAmount) || 0 });
      } else {
        setFoundCard(null);
        alert.show(t("cardNotFound"), { type: "error" });
      }
    } catch (err) {
      console.error("Check funds error: " + err);
      setFoundCard(null);
      alert.show(t("checkFundsError"), { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-page">
      <div className="container px-4 d-flex flex-column" style={{ minHeight: "100dvh" }}>
        <div className="page-title">{t("checkFunds")}</div>
        <div className="price--area mb-30">
          <h2 className="price">{foundCard?.currentAmount?.toFixed(2) ?? 0}€</h2>
          <div className="subtext">
            {foundCard ? t("remainingOnCard") : t("searchCardToDisplay")}
          </div>
        </div>

        <div className="text-22 gilroy-bold text-white mb-15">{t("cashlessCard")}</div>
        <div className="mb-15">
          <Input
            label={t("cardId")}
            style={{ height: "60px", paddingInline: "20px" }}
            value={cardId}
            onChange={(e) => setCardId(e.target.value)}
          />
        </div>

        <div className="mt-auto text-center">
          <button
            type="button"
            className="submitBtn submitBtn2 m-0 mb-1"
            onClick={onSearch}
            disabled={loading}
          >
            {loading ? t("loading") : t("search")}
          </button>
          <div className="mt-12 pb-4">{t("enterYourCardId")}</div>
        </div>
      </div>
    </div>
  );
}
